"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const Error_1 = __importDefault(require("@mui/icons-material/Error"));
const material_1 = require("@mui/material");
const lexico_1 = __importDefault(require("@tradeshift/lexico"));
const react_1 = require("react");
const zod_1 = require("zod");
const strings_1 = require("../../../../constants/strings");
const uiConstants_1 = require("../../../../constants/uiConstants");
const sessionQuery_1 = require("../../../../queries/sessionQuery");
const Root_1 = require("../../../../router/Root");
const zustandStore_1 = require("../../../../zustandStore");
const simpleButton_1 = __importDefault(require("../../../atoms/button/simpleButton"));
const styledBox_1 = require("../common/styledBox");
const styledText_1 = require("../common/styledText");
const useEmailInput_1 = require("./hooks/useEmailInput");
const lexico = new lexico_1.default();
const getWithQueryParam = (url, queryParamName, queryParamValue) => {
    const urlObj = new URL(url);
    urlObj.searchParams.append(queryParamName, queryParamValue);
    return urlObj.toString();
};
const loginSchema = zod_1.z.object({
    email: zod_1.z.email(),
});
const SSOLogin = () => {
    const [isFormLoading, setIsFormLoading] = (0, react_1.useState)(false);
    const { state: emailState, handleEmailChange, handleEmailValidation } = (0, useEmailInput_1.useEmailInput)();
    const { setLoginMethod, setNotification } = (0, zustandStore_1.useZustand)();
    const theme = (0, material_1.useTheme)();
    const isFormValid = loginSchema.safeParse({ email: emailState.value }).success;
    const handleSubmit = async (event) => {
        event.preventDefault();
        setIsFormLoading(true);
        try {
            const samlQuery = (0, sessionQuery_1.getSamlQuery)(emailState.value);
            const saml = await Root_1.queryClient.ensureQueryData({
                queryKey: samlQuery.queryKey,
                queryFn: samlQuery.queryFn,
            });
            if (saml.data && saml.data.samlEnabled) {
                globalThis.location.href = getWithQueryParam(saml.data.loginUrl, 'relayState', 'tradeshift-go');
            }
            else {
                setNotification([
                    {
                        type: strings_1.notificationStrings.WARNING,
                        message: lexico.trc('Warning message', 'You entered an incorrect email address or SSO is not enabled.'),
                    },
                ]);
            }
        }
        catch {
            setNotification([
                {
                    type: strings_1.notificationStrings.WARNING,
                    message: lexico.trc('Warning message', 'An error occurred, please try again later.'),
                },
            ]);
        }
        finally {
            setIsFormLoading(false);
        }
    };
    return ((0, jsx_runtime_1.jsxs)("form", { "data-testid": "form", style: {
            padding: `0 ${theme.tsGoUnit.tsUnit} ${theme.tsGoUnit.tsUnit}`,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: theme.tsGoUnit.tsUnit,
        }, onSubmit: handleSubmit, children: [(0, jsx_runtime_1.jsxs)(material_1.FormControl, { style: { padding: 0 }, fullWidth: true, variant: "outlined", error: emailState.isError, children: [(0, jsx_runtime_1.jsx)(material_1.TextField, { "data-testid": "email", label: lexico.tr('Email'), style: { padding: 0, margin: 0 }, type: "email", required: true, fullWidth: true, margin: "normal", variant: "outlined", autoComplete: "off", value: emailState.value, error: emailState.isError, onChange: e => handleEmailChange(e.target.value), onBlur: handleEmailValidation, slotProps: {
                            htmlInput: {
                                'data-testid': 'email',
                            },
                            inputLabel: {
                                style: { fontWeight: theme.typography.tsFontWeight.default },
                            },
                        } }), emailState.isError && ((0, jsx_runtime_1.jsxs)(material_1.FormHelperText, { style: { marginLeft: 0 }, children: [(0, jsx_runtime_1.jsx)(Error_1.default, { fontSize: "small", style: { verticalAlign: 'middle' } }), " ", lexico.tr('Invalid email address')] }))] }), (0, jsx_runtime_1.jsx)(material_1.Button, { "data-testid": "login-button", style: {
                    width: '100%',
                    fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
                }, color: uiConstants_1.UI_BUTTON_PRIMARY, disabled: !isFormValid, type: "submit", loading: isFormLoading, loadingPosition: "start", startIcon: (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, {}), variant: "contained", children: lexico.trc('Form input label', 'Use single signon to sign in') }), (0, jsx_runtime_1.jsx)(styledBox_1.StyledBox, { children: (0, jsx_runtime_1.jsx)(styledText_1.StyledText, { variant: "body1", children: lexico.trc('Form input label', 'Or use your credentials') }) }), (0, jsx_runtime_1.jsx)(simpleButton_1.default, { dataTestId: "backToLogin-btn", style: {
                    width: '100%',
                    border: `1px solid ${theme.palette.tsGoColor.pink}`,
                    color: theme.palette.tsGoColor.pink,
                    fontSize: theme.typography.pxToRem(theme.typography.tsFontSize.default),
                }, color: uiConstants_1.UI_BUTTON_SECONDARY, label: lexico.trc('Form input label', 'Back to login'), onClick: () => setLoginMethod({ isPasswordLogin: true }) })] }));
};
exports.default = SSOLogin;
